module.exports = __webpack_public_path__ + "static/media/arquitect_2.67a23416.jpeg";